/**
 * Sorts numbers in ascending order.
 *
 * @example
 * [3, 1, 2].sort(sortNumbers);
 */
export default function sortNumbers(first: number, second: number): number {
  return first - second;
}
